
export enum BulkSubscriptionStatus {
    INITIALIZING = 'INITIALIZING',
    PENDING = 'PENDING',
    UPDATING = 'UPDATING',
    READY = 'READY',
}

export interface BulkSubscription {
    attributes: string[];
    combinedAttributes: string;
    createdAt: number;
    createdById: number;
    createdByName: string;
    id: number;
    label: string;
    name: string;
    description?: string;
    status: BulkSubscriptionStatus;
    active: boolean;
    updatedAt: number;
    updatedById: number;
    updatedByName: string;
};

export interface BulkSubscriptionEntry {
    combinedValues: string;
    entryMap: {
        [key: string]: string;
    };
    status: BulkSubscriptionStatus;
    bulkSubscriptionId: number;
}
